import { render } from "./BlockSection.vue?vue&type=template&id=456e7246&scoped=true"
const script = {}

import "./BlockSection.vue?vue&type=style&index=0&id=456e7246&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456e7246"]])

export default __exports__